export default {
  IRK_REGION_UUID: '1317c214-ca12-e8cd-e875-76073f3befa6',
};
